import { Outlet, useParams } from 'react-router-dom'

import useDocumentTitle from 'components/useDocumentTitle'
import { useGetCampaignById } from 'features/campaigns/campaigns_api'

export function CampaignRouteLayout() {
  const { id } = useParams<{ id: string }>()
  const { data: campaign } = useGetCampaignById(Number(id ?? -1))
  useDocumentTitle(`${campaign?.name ?? 'Campaign'} - Campaigns - First Bite`)
  return <Outlet />
}
